import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  alert: {
    color: theme.palette.white.main,
    margin: theme.spacing(1.25, 0),
    padding: theme.spacing(0.625),
    width: '100%',
    fontSize: '0.8rem',
    fontWeight: '600',
  },
}));

export const color = {
  warning: '#eaa11e',
  success: '#73b20d',
  alert: '#b20d35',
};

export default useStyles;
